<template>
  <v-navigation-drawer elevation="5" :clipped="$vuetify.breakpoint.lgAndUp" app v-model="drawer">
    <v-list nav>
      <v-list-item-group color="accent">
        <template v-for="item in items">
          <v-divider :key="item.id" class="my-1" v-if="item.divider" />
          <v-list-group
            :key="item.id"
            :prepend-icon="item.icon"
            v-else-if="item.children && item.children.length > 0"
          >
            <template v-slot:activator>
              <v-list-item-title>{{item.text}}</v-list-item-title>
            </template>

            <template v-for="(subitem, index) in item.children">
              <drawer-item
                @click="didTapItem($event)"
                :key="subitem.ref.params.chapterID"
                :item="subitem"
                :index="index" />
            </template>
          </v-list-group>
          <drawer-item @click="didTapItem($event)" :key="item.id" :item="item" v-else />
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { db, rdb } from '@/firebase/config';
import DrawerItem from './DrawerItem.vue';

export default {
  components: { DrawerItem },
  mounted() {
    this.$bind('unorderedChapters', db.collection('chapters'));
  },
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
  },
  firebase: {
    chapterOrder: rdb.ref('chapterOrder'),
    bookData: rdb.ref('bookData'),
  },
  data: () => ({
    chapterOrder: null,
    unorderedChapters: [],
    introItems: [
      {
        id: 'downloadBook',
        icon: 'get_app',
        text: 'Baixar Livro',
        ref: 'downloadBook',
      },
      {
        id: 'introduction',
        icon: 'home',
        text: 'Introdução',
        ref: '/',
      },
      { divider: true },
    ],
  }),
  methods: {
    didTapItem(ref) {
      if (ref === 'downloadBook') {
        window.open(this.bookData.url);
      } else {
        this.$router.push(ref).catch(() => {});
      }
    },
  },
  computed: {
    chapters() {
      if (this.chapterOrder == null) {
        return [];
      }
      const shown = this.unorderedChapters.slice();
      shown.sort(this.sortChapters);
      return shown;
    },
    sortChapters() {
      return (a, b) => {
        const indexA = this.chapterOrder.indexOf(a.id);
        const indexB = this.chapterOrder.indexOf(b.id);
        return indexA - indexB;
      };
    },
    items() {
      const items = this.introItems
        .concat(this.chaptersItem);
      return items;
    },
    chaptersItem() {
      return [{ icon: 'book', text: 'Capítulos', children: this.chapterItems }];
    },
    chapterItems() {
      return this.chapters.map(chapter => ({
        ref: { name: 'chapter', params: { chapterID: chapter.id } },
        icon: chapter.icon ? chapter.icon : 'insert_drive_file',
        text: chapter.title,
      }));
    },
    drawer: {
      get() {
        return this.$vuetify.breakpoint.lgAndUp || this.$props.showDrawer;
      },
      set(v) {
        this.$emit('drawerChanged', v);
      },
    },
  },
};
</script>
